import { ApiKeyModel, ApiKeyScopeRefType } from '../../../../gamma-api';

export const MAIN_CLASS_NAME = 'api-key-modal';
export const MODAL_CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const FORM_ITEM_CLASS_NAME = `${MODAL_CONTENT_CLASS_NAME}__form-item`;
export const X_TOKEN_CLASS_NAME = `${FORM_ITEM_CLASS_NAME}__x-token`;
export const COPY_ID_BUTTON_CLASS_NAME = `${X_TOKEN_CLASS_NAME}__copy-id-button`;

export const EMPTY_API_KEY: ApiKeyModel = {
  name: '',
  scope_ref: {
    id: '',
    type: ApiKeyScopeRefType.Project,
  },
  api_key_id: '',
  roles: [],
  x_token: '',
};
